import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { AffiliationTeamStyles } from './Style'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getAffiliationsTeamFetch, getAffiliationTeamFetch } from 'store/middlewares/user.crud'
import { Table } from 'components'
import { isEmpty } from 'lodash'
import { schoolHooks } from '.'
import { initialPage, initialPageSize } from 'keys/pagination'
import { WrapDataGrid } from 'components/DataGrid/Style';
import { dataGridModel } from 'keys'
import { getGradesFetch } from 'store/middlewares/testTakers.crud'
import allClassess from "mock/classess"
import qc from 'keys/queryClient'

const AffiliationTeam = () => {
    const { affiliationID } = useParams()

    const [page, setPage] = useState(initialPage)
    const [rowOpen, setRowOpen] = useState(null)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [searchVal, setSearchVal] = useState("")
    const [sorting, setSorting] = useState([])
    const [filters, setFilters] = useState({})

    const teamColumns = schoolHooks.useTeamTableColumns()
    const userColumns = schoolHooks.useUserTableColumns()

    const roles = useQuery({
        queryKey: [qc.roles],
    })

    // כדאי להעביר למקום סטטי ולקרוא פעם אחת בלבד
    const grades = useQuery({
        queryKey: [qc.grades],
        queryFn: async () => {
            const { data } = await getGradesFetch()
            return data
        },
        refetchOnWindowFocus: false
    })

    const filterSchema = {
        primary: [
            { key: "roles", overrides: { name: "roles", labelKey: "label", multiple: true, placeholder: "תפקיד", options: roles.data } },
            { key: "grade", overrides: { name: "grade", multiple: false, placeholder: "שכבה", options: grades.data } },
            { key: "school_class", overrides: { width: 80, name: "school_class", placeholder: "מספר כיתה", options: allClassess } },
        ]
    }

    // מחזיר את כל התפקידים של משתמש מסויים - מוצג בפתיחה המקוננת של משתמש
    const userOptions = queryOptions({
        queryKey: [qc.affiliationUser, rowOpen],
        queryFn: async () => {
            const params = {
                affiliation: affiliationID,
                custom_user: rowOpen,
                page, page_size: pageSize
            }
            const { data } = await getAffiliationsTeamFetch(params)
            return data
        },
        enabled: !!rowOpen
    })

    // מציג את כל המשתמשים בצוות הבית ספר
    // סופר יוזר רואה משתמשים מכל סוגי התפקידים
    // משתמש רגיל רואה רק משתמשים מתפקידים שהגדרנו מתוך רשימה מקומית
    const teamOptions = queryOptions({
        queryKey: [qc.affiliationTeam, searchVal, sorting, page, pageSize, filters],
        queryFn: async () => {
            const { data } = await getAffiliationTeamFetch({ page, pageSize, search: searchVal, sorting, affiliation: affiliationID, model: qc.affiliationTeam, ...filters })
            return data
        }
    })

    const user = useQuery(userOptions)
    const team = useQuery(teamOptions)

    return (
        <AffiliationTeamStyles>
            <WrapDataGrid>
                <Table
                    filterSchema={filterSchema}
                    filterValues={filters}
                    onFilterChange={setFilters}
                    withTitle
                    loading={team.isFetching || isEmpty(team.data)}
                    data={team.data || []}
                    columns={teamColumns}
                    page={page}
                    setPage={setPage}
                    visibilityModelKey={dataGridModel.affiliation_team}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={teamOptions.queryKey}
                    tableH={"100%"}
                    rowOpen={rowOpen}
                    setRowOpen={setRowOpen}
                    collapse={{
                        show: true,
                        columns: userColumns,
                        showToolbar: true,
                        data: user.data?.results || { results: [] },
                        onCollapse: () => { },
                        showChollapseIcon: true,
                        // visibilityModelKey: dataGridModel.users,
                    }}
                />
            </WrapDataGrid>
        </AffiliationTeamStyles>
    )
}

export default AffiliationTeam